import { render } from "./AdminNotificationCreate.vue?vue&type=template&id=43a542aa&scoped=true&ts=true&lang=true"
import script from "./AdminNotificationCreate.vue?vue&type=script&lang=ts"
export * from "./AdminNotificationCreate.vue?vue&type=script&lang=ts"

import "./AdminNotificationCreate.vue?vue&type=style&index=0&id=43a542aa&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a542aa"]])

export default __exports__